<template>
  <aha-modal
    @hide="hide"
    :title="$i18nPresenter.t(title)"
    width="425px"
    v-if="isShowCongrat"
  >
    <div class="modal-body">
      <img
        class="mb-4 w-full"
        src="@/assets/images/community/publish-success.png"
      />
      <p v-html="$i18nPresenter.t(message)">
      </p>
    </div>
    <template #action>
      <span
        class="text-base-80 font-bold text-link mr-4"
        @click="onClickDoneCongratModal()"
      >
        {{ $i18nPresenter.t('Done') }}
      </span>
      <aha-button
        v-show="!isInTemplateLibrary"
        @click="clickViewTemplate(published)"
      >
        <span class="font-bold ml-1">{{ $i18nPresenter.t("View template") }}
          <aha-icon width="20" height="20" name="open-new-window" />
        </span>
      </aha-button>
    </template>
  </aha-modal>
  <aha-modal
    width="750px"
    @hide="closeEditInfoModal"
    title="Template info"
    :presentation-title="published.name"
    :headerTitle="$i18nPresenter.t('Published successfully!')"
    :headerSubTitle="$i18nPresenter.t('yourTemplateIsNowAvailable', {title: published.name})"
    :hideHeader="hideHeader"
    :showCustomHeader="showCustomHeader"
    :contentCustomHeader="'Publish'"
    v-else
  >
    <div class="modal-body">
      <setting-metadata
        :presentation="published"
        :isInSettingTab="false"
        :hide="hide"
        :currentCategories="currentCategories"
      ></setting-metadata>
    </div>
  </aha-modal>
</template>
<script>
import SettingMetadata from '@/components-v2/presentation-editor/editor-header/SettingMetadata.vue'
import Utils from '@/util'

export default {
  components: {
    SettingMetadata,
  },
  props: {
    title: {
      type: String,
      default: 'Awesome!',
    },
    hide: {
      type: Function,
      default: () => {},
    },
    message: {
      type: String,
      default: 'Your templates are now available in the Template Library. Thanks for your contribution.',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    showCustomHeader: {
      type: Boolean,
      default: true,
    },
    published: {
      type: Object,
      default: () => ({}),
    },
    forceEditMode: {
      type: Boolean,
      default: false,
    },
    forceCongratMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowCongrat: true,
      isShowUploadImage: false,
      isShowCropImage: false,
    }
  },
  computed: {
    isInTemplateLibrary() {
      return this.$route.name === 'TemplateLibrary'
    },
    currentCategories: {
      get() {
        if (this.published.PresentationsCategories) {
          return this.published.PresentationsCategories // nice for data return from elasticsearch
        }
        return this.$store.state.presentation.PresentationsCategories // nice for state in setting
      },
    },
  },
  mounted() {
    if (this.checkIfHideCongrat(this.published)) {
      this.isShowCongrat = false
    }
  },
  methods: {
    checkIfHideCongrat(presentation) {
      if (this.forceCongratMode) {
        return false
      }
      if (!presentation.customThumbnailImage || !presentation.description
        || this.forceEditMode || presentation.name === 'My new presentation'
        || (presentation.categories && !presentation.categories.length)) {
        return true
      }
      return false
    },
    async handleUploadImage(imageUrl) {
      this.customThumbnailImageUrl = imageUrl
      this.isShowCropImage = true
      this.isShowUploadImage = false
    },
    hideUploadImageModal() {
      this.isShowUploadImage = false
    },
    clickViewTemplate(presentation) {
      Utils.mixpanelTracking('Publish successful pop-up', 'Publish successful > Preview template')
      const preViewRoute = this.$router.resolve({
        path: '/apps/template-library',
        query: { preview: presentation.shareCode },
      })
      window.open(preViewRoute.href, 'blank')
    },
    onClickDoneCongratModal() {
      Utils.mixpanelTracking(null, 'Done editing template info')
      this.hide()
    },
    closeEditInfoModal() {
      const el = document.getElementById('zsiq_float')
      if (el) {
        el.style.display = 'block'
      }
      Utils.mixpanelTracking(null, 'Edit template info > Close')
      this.hide()
    },
  },
}
</script>
<style lang="scss" scoped>
.slide-image-config {
  background-color: #f2f2f2;
  .image-box {
    margin: auto 10px auto 1rem;
    img {
      max-width: 150px;
      max-height: 90px;
      border-radius: 0.5rem;
    }
  }
}
.text-area {
  position: relative;

  textarea {
    width: 100%;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    padding-left: 1rem;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 40px;
    min-height:3rem;
    height: 7rem;
    border: 1px solid #ddd;
    border-radius: 0.25rem;
    &:hover {
      border: 1px solid #348EF6;
      border-radius: 0.25rem;
    }
    &:focus {
      outline: none;
      -webkit-appearance: none;
    }
  }

  .count-text {
    position: absolute;
    font-size: 14px;
    right: 18px;
    top: 15px;
    color: #999;
  }
}

</style>
